(function () {
  'use strict';

  function initInfiniteScroll(sentinel) {
    if (sentinel.dataset.infiniteScrollInitialized === 'true') return;
    sentinel.dataset.infiniteScrollInitialized = 'true';

    var sectionId = sentinel.getAttribute('data-section-id');
    var grid = document.getElementById('product-grid');
    var loader = sentinel.querySelector('.infinite-scroll-spinner');
    var isLoading = false;

    if (!grid || !sectionId) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    }, { rootMargin: '400px 0px 400px 0px' });

    observer.observe(sentinel);

    function appendWithFade(newGrid) {
      var nodes = Array.prototype.slice.call(newGrid.children);
      nodes.forEach(function (node) {
        node.classList.add('infinite-scroll-fade-in');
        grid.appendChild(node);
      });
    }

    function loadNextPage() {
      var nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl || isLoading) return;
      isLoading = true;
      if (loader) loader.style.display = 'block';

      var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
      var fetchUrl = nextUrl + separator + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('product-grid');
          if (newGrid) {
            appendWithFade(newGrid);
          }

          var newSentinel = doc.getElementById(sentinel.id);
          var newNextUrl = newSentinel ? newSentinel.getAttribute('data-next-url') : null;

          if (newNextUrl) {
            sentinel.setAttribute('data-next-url', newNextUrl);
          } else {
            sentinel.removeAttribute('data-next-url');
            observer.unobserve(sentinel);
            observer.disconnect();
          }
        })
        .catch(function (error) {
          console.error('Infinite scroll failed to load next page:', error);
          observer.unobserve(sentinel);
        })
        .finally(function () {
          isLoading = false;
          if (loader) loader.style.display = 'none';
        });
    }
  }

  function setup() {
    var sentinels = document.querySelectorAll('.infinite-scroll-sentinel');
    sentinels.forEach(function (sentinel) {
      if (!sentinel.getAttribute('data-next-url')) return;
      initInfiniteScroll(sentinel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);

  // Re-scan for sentinels whenever the product grid container is replaced
  // (e.g. by facets.js after a mobile "Filter and Sort" / desktop filter change).
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && window.MutationObserver) {
    var mutationObserver = new MutationObserver(function () {
      setup();
    });
    mutationObserver.observe(gridContainer, { childList: true, subtree: true });
  }
})();
